import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import EntityStore from 'stores/EntityStore';

import {UsersByIds, UsersByIdsVariables} from './__generated/UsersByIds';
import {USERS_BY_IDS_QUERY} from './ResourcePresenceView';

export default function ResourceLockBannerMessage({
  userId,
  fileTypeName = ModelTypeConstants.ENTRY,
}: {
  userId: string;
  fileTypeName?: string;
}): JSX.Element {
  const userIds = [userId];
  const result = useBenchlingQuery<UsersByIds, UsersByIdsVariables>(USERS_BY_IDS_QUERY, {
    variables: {userIds},
  });
  const defaultMessage = <>Editing is disabled because another user is working on this {fileTypeName}</>;
  if (result.type === QueryResultType.ERROR || result.type === QueryResultType.PENDING) {
    return defaultMessage;
  } else {
    const user = result.data.users[0];
    if (isInaccessible(user)) {
      return defaultMessage;
    }

    if (user.id === EntityStore.currentUser()?.id) {
      return <>Editing is disabled because you are editing this {fileTypeName} in another window</>;
    }

    return (
      <>
        Editing is disabled because <b>{user.name}</b> is working on this {fileTypeName}
      </>
    );
  }
}
